module.exports = __webpack_public_path__ + "img/config_carousel_03.8fb98bc9.jpg";